import { reactive, ref, isRef } from 'vue'
import type { Ref } from 'vue'
import { useForm11 } from './useForm11'

/**
 * Obtain the reactive state object for a given question/form.
 * The object lives inside `form11.formData`, so it is automatically
 * persisted via the existing localStorage watcher and restored by resume().
 *
 * Each field is stored as a reactive property for simplicity.
 */
export function useQuestionState<T extends Record<string, any>>(
  key: string,
  defaults: T,
): T {
  const { formData } = useForm11()

  if (!formData[key]) {
    formData[key] = reactive({ ...defaults })
  } else {
    // Ensure existing fields are reactive properties (for resume from localStorage)
    const existingData = formData[key]
    for (const field in defaults) {
      if (existingData[field] === undefined) {
        existingData[field] = defaults[field]
      }
    }
  }

  return formData[key] as T
}
